import { Button, Container, ListItemButton, ListItemText } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { setBreadcumbs, setIsShowBack, setTitle } from "../../../../containers/containers.reducer";
import checkAccess from "../../../../shared/checkAccess";
import CustomModal from "../../../../shared/CustomModal";
import CustomTable from "../../../../shared/CustomTable";
import notificationError from "../../../../shared/notificationError";
import notificationSuccess from "../../../../shared/notificationSuccess";
import { deleteEmployee } from "../employee.api";
import EmployeeEdit from "./EmployeeEdit";
import { Key } from "@mui/icons-material";
import EmployeeEditPassword from "./EmployeeEditPassword";

export default function Employee() {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [dataSelected, setDataSelected] = useState<any>({})
    const [modalEdit, setModalEdit] = useState(false)
    const [modalEditPassword, setModalEditPassword] = useState(false)
    const [timeGetData, setTimeGetData] = useState<any>(undefined)

    useEffect(() => {
        dispatch(setTitle("Master Data"))
        dispatch(setIsShowBack(false))
        dispatch(setBreadcumbs([
            {
                name: "Master Data",
                url: ""
            },
            {
                name: "District",
                url: "/master/district"
            }
        ]))
    }, [])

    const handleCloseModal = (isReload: boolean) => {
        setModalEdit(false)
        setModalEditPassword(false)
        if (isReload) {
            setTimeGetData(new Date().getTime())
        }
    }

    const handleDelete = (id: string) => {
        Swal.fire({
            icon: "question",
            title: "Are you sure to delete this data?",
            showCancelButton: true
        })
            .then(response => {
                if (response.isConfirmed) {
                    dispatch<any>(deleteEmployee(id))
                        .unwrap()
                        .then((response: any) => {
                            if (response.status === 200) {
                                notificationSuccess("success delete employee")
                                setTimeGetData(new Date().getTime())
                            }
                            else {
                                notificationError(response)
                            }
                        })
                }
            })
    }

    return (
        <Container maxWidth='xl'>
            <CustomModal
                open={modalEdit}
                onClose={handleCloseModal}
                title="Edit Employee"
                component={
                    <EmployeeEdit onClose={handleCloseModal} data={dataSelected} />
                }
            />
            <CustomModal
                open={modalEditPassword}
                onClose={handleCloseModal}
                title="Reset Password"
                component={
                    <EmployeeEditPassword onClose={handleCloseModal} data={dataSelected} />
                }
            />
            <CustomTable
                url={"/employee"}
                columns={[
                    {
                        name: "Name",
                        key: "name"
                    },
                    {
                        name: "NIK",
                        key: "nik"
                    },
                    {
                        name: "Email",
                        key: "email"
                    },
                    {
                        name: "Team",
                        key: "team_names"
                    },
                    {
                        name: "Main Speciality",
                        customRender: (props: any) => {
                            let koj = props.data.koj_list ? JSON.parse(props.data.koj_list).filter((d: any) => d.is_active === 1) : []
                            let kojString = koj.map((d: any) => { return d.koj_name }).join(', ')
                            return (
                                <td>
                                    {kojString}
                                </td>
                            )
                        }
                    },
                    {
                        name: "Speciality",
                        customRender: (props: any) => {
                            let koj = props.data.koj_list ? JSON.parse(props.data.koj_list).filter((d: any) => d.is_additional === 1) : []
                            let kojString = koj.map((d: any) => { return d.koj_name }).join(', ')
                            return (
                                <td>
                                    {kojString}
                                </td>
                            )
                        }
                    },
                    {
                        name: "Position",
                        key: "position_name"
                    },
                    {
                        name: "Shift",
                        key: "shift_name"
                    },
                    {
                        name: "Status",
                        key: "status",
                        customRender: (props: any) => {
                            return (
                                <td>
                                    {props.data.is_active === 1
                                        ? (
                                            <span>
                                                {props.data.status}
                                            </span>
                                        )
                                        : (
                                            <span>
                                                Inactive
                                            </span>
                                        )
                                    }
                                </td>
                            )
                        }
                    }
                ]}
                headerActions={(props: any) => (
                    <Fragment>
                        {checkAccess("CREATE") &&
                            <Button
                                variant="contained"
                                onClick={() => navigate('/master/employee/add')}
                            >
                                New Employee
                            </Button>
                        }
                    </Fragment>
                )}
                rowActions={(props: any) => (
                    <Fragment>
                        {checkAccess("EDIT") &&
                            <ListItemButton onClick={() => { setDataSelected(props.data); setModalEdit(true) }}>
                                <ListItemText>Edit</ListItemText>
                            </ListItemButton>
                        }
                        {checkAccess("DELETE") &&
                            <ListItemButton onClick={() => handleDelete(props.data.id)}>
                                <ListItemText>Delete</ListItemText>
                            </ListItemButton>
                        }
                    </Fragment>
                )}
                rowActionsAdditional={(props: any) => (
                    <Fragment>
                        {checkAccess("EDIT_PASSWORD") &&
                            <Button
                                color="warning"
                                variant="outlined"
                                startIcon={<Key />}
                                onClick={() => { setDataSelected(props.data); setModalEditPassword(true) }}
                            >
                                Change Password
                            </Button>
                        }
                    </Fragment>
                )}
                row
                timeGetData={timeGetData}
            />
        </Container>
    )
}